import { useNavigate } from "react-router-dom";


export const Home = () => {
  return (
    window.location.href = "https://leningradcenter.ru/"
  )
  // return (
  //   // <div>
  //   //   <video className="img-fluid d-none d-md-block d-lg-block d-xl-block w-100" autoPlay playsInline loop muted>
  //   //     <source src="/Content/Lenta.mp4" type="video/mp4;" codecs="avc1.42e01e, mp4a.40.2" />
  //   //   </video>
  //   //   <video className="d-md-none d-lg-none d-xl-none w-100" autoPlay playsInline loop muted>
  //   //     <source src="/Content/Vertical.mp4" type="video/mp4;" codecs="avc1.42e01e, mp4a.40.2" />
  //   //   </video>
  //   //   <div className='text-center'>
  //   //     <h1 className='mt-5'>
  //   //       Сайт находиться в разработке
  //   //     </h1>
  //   //     <button className='btn btn-lc' onClick={handleClick}>Перейти на основной сайт</button>
  //   //   </div>
  //   // </div>
  // );
}
